interface IRequestResponse {
    success: boolean;
    response: string;
}

import * as uiv from "uiv"

export class GlobalFetchRequestsHandler {
    static handle(requestResponse: IRequestResponse) {

        const type = requestResponse.success ? "success" : "warning";

        const brokenString = requestResponse.response.split("\n").join("<br>");

        uiv.Notification.notify({
            type: type,
            //title: "Notification",
            content: brokenString,
            dismissible: true,
            placement: "bottom-right",
            duration: requestResponse.success ? 3000 : 0,
            html: true
        });
    }

}


// WEBPACK FOOTER //
// ./ClientApp/infrastructure/requestResponse.ts